import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import isNull from 'lodash/isNull';
import { isIOSDevice, isMobile, isWhiteLabel } from 'shared/util/utility';
import { IState } from 'shared/interface/state';
import localizationConstants from 'shared/util/translation/constant';
import { Translate } from '../translate/translate';
import { CloseIcon } from '../icons/icons';
import StippzLogo from 'assets/images/mini-logo.png';
import EWELogo from 'assets/images/EWE-small-logo.png';

const InstallationPrompt: FC = () => {
	const isLogin: boolean = useSelector((state: IState) => state.auth.isLogin);

	const [isShowInstall, setIsShowInstall] = useState(false);
	const [isShowIOSInstall, setIsShowIOSInstall] = useState(false);
	const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

	useEffect(() => {
		const handleBeforeInstallPrompt = (e: Event) => {
			e.preventDefault();
			setDeferredPrompt(e);

			setTimeout(() => {
				setIsShowInstall(true);
			}, 10);
		};

		const handleAppInstalled = () => {
			setIsShowInstall(false);
		};

		window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
		window.addEventListener('appinstalled', handleAppInstalled);

		return () => {
			window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
			window.removeEventListener('appinstalled', handleAppInstalled);
		};
	}, []);

	useEffect(() => {
		if (isIOSDevice() && isLogin) {
			if (isNull(localStorage.getItem('isIOSLogin'))) {
				setIsShowIOSInstall(true);
				localStorage.setItem('isIOSLogin', 'true');
			}
		}
	}, [isLogin]);

	const handleInstallClick = () => {
		if (deferredPrompt) {
			(deferredPrompt as any).prompt(); // Cast to any due to non-standard prompt method
			deferredPrompt.userChoice.then((choiceResult: any) => {
				if (choiceResult.outcome === 'accepted') {
					console.log('User accepted the installation');
				} else {
					console.log('User dismissed the installation');
				}
				setDeferredPrompt(null);
				setIsShowInstall(false);
			});
		}
	};

	return (
		<>
			{((isShowInstall && isMobile()) || (isShowIOSInstall && isIOSDevice())) && (
				<div className='install-prompt-wrapper'>
					<div className='install-prompt'>
						<div
							className='close-icon-wrapper'
							onClick={() => {
								setIsShowInstall(false);
								setIsShowIOSInstall(false);
							}}
						>
							<CloseIcon className='close--icon' />
						</div>
						<div className='justify-align--center'>
							<img src={isWhiteLabel ? EWELogo : StippzLogo} alt='Stippz Logo' className='prompt-logo' />
							{isShowInstall && (
								<div>
									<p className='font-size--sm font--medium mb--5'>
										Install {isWhiteLabel ? 'EBO' : 'STIPPZ'}
									</p>
									<p className='font-size--xs mr--5'>
										{window.location.protocol}//{window.location.host}
									</p>
								</div>
							)}
							{isShowIOSInstall && (
								<p className='font-size--sm font--medium mb--5 pr--20'>
									<Translate
										text={
											isWhiteLabel
												? localizationConstants.whiteLabelIOSInstall
												: localizationConstants.iOSInstall
										}
									/>
								</p>
							)}
						</div>
						{isShowInstall && (
							<p
								className='justify-align--center font-size--sm font--bold mr--20'
								onClick={handleInstallClick}
							>
								Install
							</p>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default InstallationPrompt;
